import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import { FormItemLayout } from 'client/ui/form/FormItem';
import { TextInputItem } from 'client/ui/form/input/TextInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPDNDFiscalCodeFormProps {
  layout: FormItemLayout;
}

export function PDNDFiscalCodeForm(props: IPDNDFiscalCodeFormProps) {
  const { layout } = props;
  const { t } = useTranslation();
  return (
    <>
      <FormDividerSpace
        title={t(
          'verification.c020.form.fiscalCodeSearch',
          'Ricerca per Codice Fiscale'
        )}
        layout={layout}
        style={{ marginTop: 0 }}
      />
      <TextInputItem
        label={t(
          'verification.c020.form.fiscalCodeSearch.label.codiceFiscale',
          'Codice Fiscale'
        )}
        name="search.codiceFiscale"
      />
    </>
  );
}
